module.exports = __webpack_public_path__ + "static/media/location_id_help.8aaaed72.png";